var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithub1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "63px",
    viewBox: "0 0 63 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,3 C28.6126984,3 36,10.3873016 36,19.5 C36,27.1988451 30.7271794,33.6661569 23.5958117,35.4876618 L23.5954285,35.4926274 C22.4726025,35.8040846 21.2262154,35.9721478 19.8562671,35.996817 C19.7375743,35.9987416 19.6189341,36 19.5,36 L19.5,36 L19.855908,35.9962375 C21.1442903,35.9689733 22.3963402,35.7940327 23.5958117,35.4876618 L23.5954285,29.4810637 C23.5954285,28.7010684 22.5718088,28.0616895 22.9052835,27.6833381 C23.0481818,27.5212096 25.6513358,27.2175008 27.4117343,25.7740686 C28.8177561,24.6212062 29.4601133,23.0518865 29.5548312,21.5411763 C29.6742168,19.6370278 29.1824436,17.833281 28.0795115,16.129936 C28.2923079,13.6439595 28.1789749,12.1881898 27.7395125,11.7626268 C27.3000501,11.3370638 25.9186887,11.8325318 23.5954285,13.2490306 C22.1746643,12.9775654 20.8258359,12.8418327 19.5489432,12.8418327 C18.2720504,12.8418327 17.0751197,13.0645612 15.9581509,13.5100182 C13.1908265,11.6330117 11.6638899,11.109255 11.3773413,11.9387483 C11.0907927,12.7682416 11.0907927,14.0902131 11.3773413,15.9046627 C10.2781269,17.2980602 9.72851965,18.9908203 9.72851965,20.9829428 C9.72851965,23.9711266 11.3471449,25.3827423 12.8441939,26.3914483 C14.3412429,27.4001542 16.586495,27.21262 16.586495,27.6833381 C16.586495,27.9971502 16.2897229,28.7656443 15.6961788,29.9888205 L15.6961788,29.9888205 L13.7964562,29.9888205 C13.3464503,29.9888205 11.6683483,28.8964212 10.6999642,27.6833381 C9.73158008,26.4702551 7.47606656,26.4332653 8.10433456,27.0303562 C8.73260257,27.6274472 9.84152153,28.0448818 10.4946049,29.2413091 C11.1476882,30.4377364 10.8482234,30.7366988 12.1671862,31.6086993 C13.0464947,32.190033 14.3101496,32.3302436 15.9581509,32.029331 L15.9581509,32.029331 L16.0198949,35.6143767 C16.0860687,35.6354002 16.1545889,35.6555641 16.2254553,35.6748684 C16.6674997,35.7640983 17.1162883,35.8354844 17.5707122,35.8884064 C18.0453568,35.9436832 18.5261493,35.9788162 19.0122125,35.9929279 L19.5,36 L19.5,36 C18.1126801,36 17.0211652,35.8916228 16.2254553,35.6748684 C8.68121334,34.1559463 3,27.4914324 3,19.5 C3,10.3873016 10.3873016,3 19.5,3 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-65.2%",
    y: "-62.1%",
    width: "248.5%",
    height: "248.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.309727382 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-904.000000, -538.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(913.000000, 546.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#33343A",
    x: 0,
    y: 0,
    width: 39,
    height: 39,
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#AEB4A1",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub1);
export default __webpack_public_path__ + "static/media/github1.a5d02fd6ba07e7c29b39b8568b79174f.svg";
export { ForwardRef as ReactComponent };